module.exports = __webpack_public_path__ + "img/dat05.2df4cd41.png";